module.exports = __webpack_public_path__ + "img/navbar-logo.e3a1182c.png";